import axios from 'axios'
import { message } from 'ant-design-vue'
import qs from 'qs'

axios.defaults.withCredentials = true

// 创建axios对象
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 基础路径，默认是/ ，如果改了，会自动添加到你请求url前面
  timeout: process.env.VUE_APP_TIMEOUT // 请求超时，10000毫秒
})

// 请求拦截器
request.interceptors.request.use(config => {
  axios.defaults.withCredentials = true
  config.headers.common.token = 'devId=' + sessionStorage.getItem('devId') + '&sjt=' + sessionStorage.getItem('sjt')
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
  config.headers.Authorization = process.env.VUE_APP_AUTHORIZATION
  if (config.method === 'get') {
    config.paramsSerializer = function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    }
  }

  return config
}, function (error) {
  // 处理请求错误
  return Promise.reject(error)
})

// 相应拦截器
request.interceptors.response.use(
  (response) => {
  // 在2xx范围内的任何状态代码都会触发此功能
  // 处理响应数据
    if (response.data.code === 999) {
      message.error('未授权，请重新登录,3秒后跳转开发者站主页')
      // setTimeout(() => window.location.href="https://dev.mi.com", 3000)
    }
    return Promise.resolve(response.data)
  },
  (error) => {
    // 任何超出2xx范围的状态代码都会触发此功能
    // 处理响应错误
    console.log(error)
    console.log(typeof (error.response))
    if (typeof (error.response) === 'undefined' || error.response == null) {
      message.error('服务请求超时，请稍后再试')
      return Promise.reject(error)
    }
    console.log(error.response)
    const code = error.response.status
    switch (code) {
      case 400:
        message.error(`${code} 错误请求`)
        break
      case 401:
        message.error(`${code} 未授权，请重新登录`)
        break
      case 404:
        message.error(`${code} 请求地址不存在`)
        break
      case 428:
        message.error(`${code} 请求参数错误`)
        break
      case 500:
        message.error(`${code} 服务器端错误`)
        break
      case 503:
        message.error(`${code} 服务不可用`)
        break
      default:
        message.error(`${code} ${error.response.statusText}`)
        break
    }
    if (JSON.stringify(error.message).includes('timeout')) {
      message.error('服务请求超时，请稍后再试')
    }
    return Promise.reject(error)
  })

export default request // 导出自定义创建的 axios 对象
